import { memo } from "react";

const BzScrollContainer = ({ contaierref, onScrollEnd, classname, ...props }) => {
    return (
        <div ref={contaierref} onScroll={onScrollEnd} className={classname} {...props}>
            {props?.children}
        </div>
    );
};

export default memo(BzScrollContainer);